export const CAMPAIGN_STATUS = {
  paused: 'paused',
  running: 'running',
  draft: 'draft',
} as const;
export type CampaignStatus = (typeof CAMPAIGN_STATUS)[keyof typeof CAMPAIGN_STATUS];

export const isCampaignRunning = (status: CampaignStatus) => status === CAMPAIGN_STATUS.running;

export const isCampaignDraft = (status: CampaignStatus) => status === CAMPAIGN_STATUS.draft;
